angular
  .module('customer')

  .directive('customerHeadquarter', function() {
    return {
      restrict: 'E',
      replace: true,
      require: '^ngModel',
      scope: {
        headquarter: '=ngModel',
        save: '&',
        undo: '&'
      },
      templateUrl: 'custom/customer/views/partials/customerHeadquarter.html'
    };
  });
